// extracted by mini-css-extract-plugin
export var actions = "_kb-g";
export var benefitCard = "_kb-b";
export var benefitIcon = "_kb-d";
export var benefitLabel = "_kb-f";
export var benefits = "_kb-a";
export var benefitsSection = "_kb-8";
export var bodyText = "_kb-7";
export var closeButton = "_kb-2";
export var content = "_kb-3";
export var eyebrow = "_kb-4";
export var heading = "_kb-5";
export var image = "_kb-i";
export var imagePanel = "_kb-h";
export var modal = "_kb-0";
export var offerCard = "_kb-c";
export var offerIcon = "_kb-e";
export var sectionLabel = "_kb-9";
export var shell = "_kb-1";
export var title = "_kb-6";